import React, { useMemo } from 'react';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { Table, Button } from 'react-bootstrap';

const ExcelViewer = ({data}) => {
  const columns = useMemo(() => {
    if (!data || data.length === 0) {
      return [];
    }

    return Object.keys(data[0]).map((key) => ({ key, name: key }));
  }, [data]);

  const rows = useMemo(() => {
    return data.map((row) => {
      const rowData = {};
      columns.forEach((col) => {
        rowData[col.key] = row[col.key] !== undefined && row[col.key] !== null ? row[col.key] : '';
      });
      return rowData;
    });
  }, [columns, data]);

  const handleDownload = () => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Claims Data");

    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(blob, `document_${new Date().toISOString().slice(0, 19).replace(/:/g, '-')}.xlsx`)
  };

  return (
    <div className='table-container'>
      <Button onClick={handleDownload} variant="secondary" className="btn-outline-steel-blue btn-light me-2 dropdown-custom-color"
>Download Excel File</Button>
        <Table striped bordered hover>
          <thead>
            <tr>
              {columns.map((col) => (
                <th key={col.key}>{col.name}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {columns.map((col) => (
                  <td key={col.key}>{row[col.key]}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </Table>
    </div>
  );
};

export default ExcelViewer;